<template>
    <template v-if="results?.results?.length">
        <p class="search-results-page" v-if="results.total_pages > 1">
            <em>Showing page {{ results.current_page }} of {{ results.total_pages }}</em>
        </p>
        <div class="featured-carousel" v-if="featuredCards.length > 0">
            <div class="search-results">
                    <Carousel :items="featuredCards.length ? featuredCards : null" :alt="Featured" :overlay="true" :type="'card'"  :selected-year-offset="searchParams.academic_year_offset"
                        :current-academic-year="currentAcademicYear" :next-academic-year="nextAcademicYear" class="carousel__featured" ref="gallery"></Carousel>
            </div>
        </div>
        <ul class="search-results">
            <li v-for="result in nonFeaturedCards" :key="id" class="search-results__item">
                <RoomCard :data="result" :selected-year-offset="searchParams.academic_year_offset"
                    :current-academic-year="currentAcademicYear" :next-academic-year="nextAcademicYear" />
            </li>
        </ul>
        <p class="search-results-page" v-if="results.total_pages > 1">
            <em>Showing page {{ results.current_page }} of {{ results.total_pages }}</em>
        </p>
        <nav class="pagination">
            <template v-if="results.total_pages > 1">
                <a :href="getPageUrl(results.current_page - 1)"
                    :class="{ 'pagination__link--disabled': results.current_page == 1 }"
                    class="pagination__link pagination__link--previous"
                    @click.prevent="setPage(results.current_page - 1)">Previous</a>

                <a v-for="page in results.total_pages" :key="page" :href="getPageUrl(page)" class="pagination__link"
                    :class="{ 'pagination__link--current': page == results.current_page }"
                    @click.prevent="setPage(page)">{{ page }}</a>

                <a 
                    :href="getPageUrl(results.current_page + 1)" class="pagination__link pagination__link--next"
                    :class="{ 'pagination__link--disabled': results.current_page == results.total_pages }"
                    @click.prevent="setPage(results.current_page + 1)">Next</a>
            </template>
        </nav>

    </template>
</template>
<script setup>
import { ref, onMounted, reactive, computed } from 'vue';
import Carousel from '@components/Carousel.vue';

const props = defineProps({
    // The search results object
    results: {
        type: Object,
        required: true
    },
    // The current academic year range as a string, e.g. 2023/24
    currentAcademicYear: {
        type: String,
        required: true
    },
    // The next academic year range as a string, e.g. 2024/25
    nextAcademicYear: {
        type: String,
        required: true
    },
    // The search params object
    searchParams: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['set-page']);

const featuredCards = computed(() => {
    return props.results?.results?.filter(result => result.featured);
});

const nonFeaturedCards = computed(() => {
    return props.results?.results?.filter(result => !result.featured);
});

// Get the URL for a given page number
const getPageUrl = (page) => {
    const params = new URLSearchParams(props.searchParams);
    params.set('current_page', page);
    return '?' + params.toString();
};

// Set the page number
const setPage = (page) => {
    props.searchParams.page = page;
    emit('set-page', page);
};
</script>